
import { 
    EDIT_ROLE,
    EDIT_ROLE_SUCCESS,
    EDIT_ROLE_FAIL, 
    EDIT_ROLE_RESET,
} from "../actions/editRoleAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const editRoleReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_ROLE:
            return {
                ...state,
                apiState: "loading",
            };
        case EDIT_ROLE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case EDIT_ROLE_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case EDIT_ROLE_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default editRoleReducer;
